import { RouteObject } from "react-router-dom";
import { lazy } from "react";

// 懒加载页面组件
const NotFound = lazy(() => import("../pages/NotFound"));
const Login = lazy(() => import("../pages/login/page"));
const Home = lazy(() => import("../pages/home/page"));
const Dashboard = lazy(() => import("../pages/dashboard/page"));
const Profile = lazy(() => import("../pages/profile/page"));
const ResetPassword = lazy(() => import("../pages/reset-password/page"));

// 首页管理
const HomepageNews = lazy(() => import("../pages/homepage/news/page"));
const HomepagePartners = lazy(() => import("../pages/homepage/partners/page"));
const HomepageAdvertisers = lazy(
  () => import("../pages/homepage/advertisers/page"),
);
const HomepageCarousel = lazy(() => import("../pages/homepage/carousel/page"));
const HomepageMap = lazy(() => import("../pages/homepage/map/page"));
const HomepageThirdParty = lazy(
  () => import("../pages/homepage/third-party/page"),
);

// 网站管理
const WebsiteSettings = lazy(() => import("../pages/website/settings/page"));
const WebsiteColumns = lazy(() => import("../pages/website/columns/page"));
const WebsiteNotifications = lazy(
  () => import("../pages/website/notifications/page"),
);
const WebsiteService = lazy(() => import("../pages/website/service/page"));
const WebsiteAssets = lazy(() => import("../pages/website/assets/page"));
const WebsiteSuccessCases = lazy(
  () => import("../pages/website/success-cases/page"),
);
const WebsitePrivacyTerms = lazy(
  () => import("../pages/website/privacy-terms/page"),
);
const WebsiteCooperationDemands = lazy(
  () => import("../pages/website/cooperation-demands/page"),
);
const WebsiteAssetConsults = lazy(
    () => import("../pages/website/asset-consults/page"),
);
const WebsitePortraits = lazy(
    () => import("../pages/website/portraits/page"),
);
const WebsitePortraitsConsults = lazy(
    () => import("../pages/website/portraits-consults/page"),
);
const WebsiteAppointments = lazy(
    () => import("../pages/website/appointments/page"),
);

// 配置管理
const ConfigCenter = lazy(() => import("../pages/config/center/page"));
const ConfigHelp = lazy(() => import("../pages/config/help/page"));
const ConfigTeam = lazy(() => import("../pages/config/team/page"));
const ConfigFAQ = lazy(() => import("../pages/config/faq/page"));
const ConfigLegal = lazy(() => import("../pages/config/legal/page"));
const ConfigPrivacy = lazy(() => import("../pages/config/privacy/page.tsx"))
const ConfigDictionaries = lazy(
  () => import("../pages/config/dictionaries/page"),
)

// 在线客服
const ServiceChat = lazy(() => import("../pages/service/chat/page"));

// 账号管理
const AccountPortal = lazy(() => import("../pages/account/portal/page"));
const AccountRequest = lazy(() => import("../pages/account/request/page"));
const AccountOnline = lazy(() => import("../pages/account/online/page"));

// 系统管理
const SystemBackend = lazy(() => import("../pages/system/backend/page"));
const SystemRoles = lazy(() => import("../pages/system/roles/page"));
const SystemMenus = lazy(() => import("../pages/system/menus/page"));
const SystemPermissions = lazy(
  () => import("../pages/system/permissions/page"),
);

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  // 首页管理
  {
    path: "/homepage/news",
    element: <HomepageNews />,
  },
  {
    path: "/homepage/partners",
    element: <HomepagePartners />,
  },
  {
    path: "/homepage/advertisers",
    element: <HomepageAdvertisers />,
  },
  {
    path: "/homepage/carousel",
    element: <HomepageCarousel />,
  },
  {
    path: "/homepage/map",
    element: <HomepageMap />,
  },
  {
    path: "/homepage/third-party",
    element: <HomepageThirdParty />,
  },
  // 网站管理
  {
    path: "/website/settings",
    element: <WebsiteSettings />,
  },
  {
    path: "/website/columns",
    element: <WebsiteColumns />,
  },
  {
    path: "/website/notifications",
    element: <WebsiteNotifications />,
  },
  {
    path: "/website/service",
    element: <WebsiteService />
  },
  {
    path: "/website/assets",
    element: <WebsiteAssets />,
  },
  {
    path: "/website/asset-consults",
    element: <WebsiteAssetConsults />,
  },
  {
    path: "/website/success-cases",
    element: <WebsiteSuccessCases />,
  },
  {
    path: "/website/privacy-terms",
    element: <WebsitePrivacyTerms />,
  },
  {
    path: "/website/cooperation-demands",
    element: <WebsiteCooperationDemands />,
  },
  {
    path: "/website/portraits",
    element: <WebsitePortraits />,
  },
  {
    path: "/website/portraits-consults",
    element: <WebsitePortraitsConsults />,
  },
  {
    path: "/website/appointments",
    element: <WebsiteAppointments />,
  },
  // 配置管理
  {
    path: "/config/center",
    element: <ConfigCenter />,
  },
  {
    path: "/config/help",
    element: <ConfigHelp />,
  },
  {
    path: "/config/team",
    element: <ConfigTeam />,
  },
  {
    path: "/config/faq",
    element: <ConfigFAQ />,
  },
  {
    path: "/config/legal",
    element: <ConfigLegal />,
  },
  {
    path: "/config/privacy",
    element: <ConfigPrivacy />,
  },
  {
    path: "/config/dictionaries",
    element: <ConfigDictionaries />,
  },
  // 在线客服
  {
    path: "/service/chat",
    element: <ServiceChat />,
  },
  // 账号管理
  {
    path: "/account/portal",
    element: <AccountPortal />,
  },
  {
    path: "/account/request",
    element: <AccountRequest />,
  },
  {
    path: "/account/online",
    element: <AccountOnline />,
  },
  // 系统管理
  {
    path: "/system/backend",
    element: <SystemBackend />,
  },
  {
    path: "/system/roles",
    element: <SystemRoles />,
  },
  {
    path: "/system/menus",
    element: <SystemMenus />,
  },
  {
    path: "/system/permissions",
    element: <SystemPermissions />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
